import { useSearchParams } from 'react-router-dom'

import './styles.css'

import { Box } from '@mui/material'

import FileUploaderToServer from './components/FileUploaderToServer'
import Filters from './components/Filters'
import Table from './components/Table'
import TitleBlock from './components/TitleBlock'
import UniquenessSelector from './components/UniquenessSelector'
import useTableDataQuery from './hooks/useTableDataQuery'
import { getFilter } from './utils/filter'
import { handleDownloadJson } from './utils/handleDownloadFile'
import { getPagination } from './utils/pagination'
import { queryDataHandler } from './utils/queryDataHandler'
import { getSort } from './utils/sort'

function App() {
  const [searchParams] = useSearchParams()

  const nameOfFile = searchParams.get('nameOfFile')
  const appliedUniqueColumns = searchParams.get('uniqueness')?.split(',') || []
  const known = searchParams.get('known') || 'all'

  const { data, isFetching, error } = useTableDataQuery(
    {
      nameOfFile: nameOfFile || '',
      paginationModel: getPagination(searchParams),
      sort: getSort(searchParams),
      appliedUniqueColumns,
      appliedFilters: getFilter(searchParams),
      known,
    },
    { enabled: !!nameOfFile }
  )

  const handleDownload = async () => {
    try {
      const fullData = await queryDataHandler({
        nameOfFile: nameOfFile || '',
        appliedFilters: getFilter(searchParams),
        appliedUniqueColumns,
        sort: getSort(searchParams),
        paginationModel: { page: 0, pageSize: 0 },
        known,
      })
      handleDownloadJson(fullData?.trace_events)
    } catch (error) {
      console.error('Error:', error)
    }
  }

  return (
    <Box
      sx={{
        maxWidth: '1920px',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <TitleBlock nameOfFile={nameOfFile || ''} />
      <FileUploaderToServer isLoading={isFetching} error={error} />
      <Filters
        key={`filters-${nameOfFile}-${searchParams.get('ts')}`}
        data={!!data && !!nameOfFile}
      />
      <UniquenessSelector
        key={`uniqueness-${nameOfFile}-${searchParams.get('ts')}`}
        data={!!data && !!nameOfFile}
      />
      <Table
        isLoading={isFetching}
        data={nameOfFile ? data : undefined}
        handleDownload={handleDownload}
        isFiltered={!!appliedUniqueColumns.length || !!Object.keys(getFilter(searchParams)).length}
      />
    </Box>
  )
}

export default App
